module.exports = __webpack_public_path__ + "vue-assets/img/logo.f4a37b1f.svg";